import type { ReactNode } from 'react';
import './WalletBalanceValue.css';

type WalletBalanceValueProps = {
    loading?: boolean;
    hidden?: boolean;
    children: ReactNode;
};

function WalletBalanceValue({ loading, hidden, children }: WalletBalanceValueProps) {
    if (loading) {
        return <span className="wallet-balance-skel" aria-hidden />;
    }

    return <span className="wallet-balance-value">{hidden ? '••••••' : children}</span>;
}

export default WalletBalanceValue;
